import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

type Params = {
	formData: { email: string; enquiryType: string } & { [k: string]: string };
	recaptchaToken: string;
};

export const saveContactFormSubmission = makeSubmitData<Params>(
	"contactForm",
	undefined,
	({ recaptchaToken, formData: { email, enquiryType, ...rest } }) => {
		return {
			enquiryType,
			email,
			_recaptcha: recaptchaToken,
			rest
		};
	}
);
